import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Workspace} from '../../../global/user-settings.dto';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceService {

  constructor(private http:HttpClient) { }

  /**
     * Fetch workspaces
     * @returns response
     */
  fetchWorkspaces(){
    return this.http.get<Workspace[]>(`workspaces`);
  }

  /**
     * Switch workspace
     * @returns response
     */
  switchWorkspace(workspaceId){
    return this.http.put(`workspaces/${workspaceId}/default`,'');
  }

  /**
     * create workspace
     * @param formData
     * @returns response
     */
  createWorkspace(formData: Omit<Workspace, 'id'>){
    return this.http.post<Workspace>('workspaces', formData);
  }

  /**
     * update workspace
     * @param formData
     * @returns response
     */
  updateWorkspace(formData: Workspace){
    return this.http.put<Workspace>(`workspaces/${formData.id}`, formData);
  }

  /**
     * delete workspace
     * @param workspaceId
     * @returns response
     */
  deleteWorkspace(workspaceId: number){
    return this.http.delete(`workspaces/${workspaceId}`);
  }
}
